import React from "react";

const Compte = (props) => {
    return <h1>Compte</h1>;
}

export default Compte;